import styled from 'styled-components/macro';
import * as breakpoints from '../../../common/mediaQueries';

export const SimplrImage = styled.div`
  flex: 1 1 auto;
  display: flex;
  justify-content: flex-end;
  background: url('/images/welcome-image/welcome_image_business_bg.svg');
  background-repeat: no-repeat;
  background-size: contain;
  background-position: right;
  height: 500px;

  @media screen and (max-width: ${breakpoints.maxTablet}) {
    height: 306px;
  }

  @media screen and (max-width: ${breakpoints.minTablet}) {
    display: none;
  }
`;
